import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.tsx'

// Sentry — só inicializa se DSN existir (deixa devs locais sem barulho).
// Wrap em try/catch defensivo: se o init falhar (versão SDK incompat, integration ausente),
// app continua renderizando normalmente em vez de tela em branco.
try {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (dsn) {
    // Diferencia prod x preview pela URL (Preview é *.vercel.app; Prod é bx.tec.br)
    const env = (() => {
      if (import.meta.env.DEV) return 'frontend-dev'
      if (location.hostname === 'bx.tec.br') return 'frontend-prod'
      return 'frontend-staging'
    })()

    Sentry.init({
      dsn,
      environment: env,
      // Defaults do v10 já incluem globalHandlers + breadcrumbs + inboundFilters.
      // Removido `integrations` explícito que causava crash em prod no deploy anterior.
      sendDefaultPii: false,
    })
    // eslint-disable-next-line no-console
    console.log(`[Sentry] initialized env=${env}`)
  }
} catch (err) {
  // eslint-disable-next-line no-console
  console.error('[Sentry] init falhou — app segue sem observabilidade:', err)
}

const root = createRoot(document.getElementById('root')!)
root.render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />} showDialog={false}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)

function ErrorFallback() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      fontFamily: 'system-ui, sans-serif',
      color: '#1f2937',
    }}>
      <div style={{ maxWidth: 480, textAlign: 'center' }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '0.5rem' }}>
          Algo deu errado
        </h1>
        <p style={{ color: '#6b7280', marginBottom: '1.5rem' }}>
          O erro foi registrado e nossa equipe foi notificada. Tente recarregar a página.
        </p>
        <button
          onClick={() => location.reload()}
          style={{
            background: '#4d7c0f',
            color: 'white',
            border: 'none',
            padding: '0.625rem 1.25rem',
            borderRadius: 8,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Recarregar
        </button>
      </div>
    </div>
  )
}
